/**
 * File-path cache for parent-scoped search: walk workspace roots, persist paths in CLI SQLite, substring search via SQL `LIKE`.
 */

export { getCwdHashForFileIndex } from './paths.js';
export { buildFileIndex, buildFileIndexAsync } from './build-file-index.js';
export { ensureFileIndex, ensureFileIndexAsync } from './ensure-file-index.js';
export {
  bridgeFileIndexIsPopulated,
  bridgeFileIndexPathCount,
  searchBridgeFilePaths,
  searchBridgeFilePathsAsync,
} from './search-file-index.js';
